import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Modal, ModalBody, ModalHeader, Spinner } from 'reactstrap';
import { useSelector } from 'react-redux';
import { BUROSHUB_URL } from 'CONST';

const PosicionDeudorReporteConsolidadoModal = ({ isOpen, toggle, datosDeudor, datosScore, selectedTimestamp }) => {
  const [isLoading, setIsLoading] = useState(true);

  const token = useSelector((state) => state.login.id_token);

  const getCsrfTokenFromCookies = () => {
    const csrfToken = document.cookie.split(';').find(cookie => cookie.trim().startsWith('bh_csrftoken='));
    return csrfToken ? csrfToken.split('=')[1] : null;
  };

  const sendAdditionalData = (csrfToken) => {
    const url = `${BUROSHUB_URL}reporte-consolidado/`;

    const options = {
      method: 'POST',
      headers: {
        'X-CSRFToken': csrfToken,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        'datos_score': datosScore,
      }),
      credentials: 'include',
    };

    fetch(url, options)
      .then((response) => {
        setIsLoading(false);
      })
      .catch((err) => {
        console.error(`Error al enviar datos adicionales a BurosHub: ${err}`);
      });
  }

  useEffect(() => {
    if (!isOpen) {
      setIsLoading(true);
      return;
    }

    const url = `${BUROSHUB_URL}login-external-user/`;

    const options = {
      method: 'GET',
      headers: {
        'X-JWT-TOKEN': token,
      },
      credentials: 'include',
    };

    fetch(url, options)
      .then((response) => {
        if (response.ok) {
          setTimeout(() => {
            const csrfToken = getCsrfTokenFromCookies();
            if (csrfToken) {
              sendAdditionalData(csrfToken);
            } else {
              console.error('No se logró extraer el token csrf de BurosHub');
            }
          }, 100); // Small delay for the cookie to set
        }
      })
      .catch((err) => {
        console.error(`Error al acceder BurosHub: ${err}`);
      });
  }, [isOpen]);

  return (
    <Modal
      isOpen={isOpen}
      style={{ maxWidth: '2000px', width: '90%' }}
      toggle={toggle}
      type="modal-warning warning-container"
    >
      <ModalHeader toggle={toggle} style={{ paddingBottom: '10px', paddingTop: '20px' }}>
        Reporte Consolidado
      </ModalHeader>
      <ModalBody style={{ paddingTop: '0px', height: '85vh' }}>
        {isLoading && datosDeudor && selectedTimestamp ? (
          <div className="spinner my-auto h-100">
            <Spinner />
          </div>
        ) : (
          <iframe
            title="Reporte BurosHub"
            src={`${BUROSHUB_URL}reporte-consolidado/?rut=${datosDeudor.rut}&fecha=${selectedTimestamp}`}
            width="100%"
            height="100%"
            style={{ border: 'none' }}
          />
        )}
      </ModalBody>
    </Modal>
  );
};

PosicionDeudorReporteConsolidadoModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
  datosDeudor: PropTypes.shape({
    rut: PropTypes.string,
    name: PropTypes.string,
    estado: PropTypes.string,
    inicio_actividad: PropTypes.string,
    actividad: PropTypes.arrayOf(PropTypes.object),
    rubro_id: PropTypes.number,
    tamano: PropTypes.string,
    email: PropTypes.string,
    phone: PropTypes.string,
    contacto: PropTypes.string,
    score: PropTypes.number,
  }).isRequired,
  datosScore: PropTypes.object.isRequired,
  selectedTimestamp: PropTypes.string,
};

PosicionDeudorReporteConsolidadoModal.defaultProps = {
  selectedTimestamp: undefined,
}

export default PosicionDeudorReporteConsolidadoModal;
